import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_MutateEntity = _resolveComponent("MutateEntity")!
  const _component_AddOffered = _resolveComponent("AddOffered")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MutateEntity, {
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
      enUK: _ctx.enUK,
      entityProps: {
      id: _ctx.invoice.id,
      clientName: _ctx.invoice.company?.client?.name,
      assignedTo: _ctx.invoice.assignedTo?.id,
      collectionStatus: _ctx.invoice.collectionStatus,
      communication: _ctx.invoice.communication,
      comment: _ctx.invoice.comment,
      promisedDate: _ctx.invoice.promisedDate,
    },
      validationRules: _ctx.validationRules,
      mutation: _ctx.UPDATE_INVOICE,
      mutationName: "updateInvoice",
      "form-options": _ctx.formOptions,
      messages: _ctx.messages,
      refetchQueries: _ctx.refetchQueries,
      "read-only-properties": ['communication', 'clientName']
    }, {
      footer: _withCtx(() => [
        (_ctx.invoice.projectId && _ctx.isUserAdmin)
          ? (_openBlock(), _createBlock(_component_BasicButton, {
              key: 0,
              class: "mutate-button",
              type: "button",
              color: "primary",
              onClick: _ctx.showAddOfferedModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("buttons.offered.offerAmount")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["enUK", "entityProps", "validationRules", "mutation", "form-options", "messages", "refetchQueries"]),
    (_ctx.isAddOfferedModalVisible && _ctx.invoice.projectId && _ctx.isUserAdmin)
      ? (_openBlock(), _createBlock(_component_AddOffered, {
          key: 0,
          onClose: _ctx.closeAddOfferedModal,
          onCreated: _ctx.handleOfferedCreated,
          "project-id": _ctx.invoice.projectId,
          "credit-note-for-id": _ctx.invoice.id,
          defaultAmountNet: _ctx.invoice.balance,
          defaultComment: `Todo: credit note for invoice ${_ctx.invoice.invoiceNumber}`
        }, null, 8, ["onClose", "onCreated", "project-id", "credit-note-for-id", "defaultAmountNet", "defaultComment"]))
      : _createCommentVNode("", true)
  ], 64))
}